/* eslint-disable import/no-cycle */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import Table, { TablePagination } from '../../molecules/table';
import Label from '../../atoms/label/label';
import Link, { LinkTheme } from '../../atoms/link/link';
import { IconType } from '../../atoms/icon/icon';
import { getLink } from '../../../routes/route';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { storeStructure } from '../../../store/reducers';
import FormValidation from '../../atoms/formEnums/formValidation';
import Button, { ButtonTheme, ButtonType } from '../../atoms/button/button';
import { composeURL } from '../../../utils/urlTools';
import { httpGet, httpPut } from '../../../store/externalCalls/httpCalls';
import { useState } from 'react';
import FormPopup from '../../molecules/formPopup/formPopup';
import { mapPagination } from '../../../store/externalCalls/api/maps';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import ButtonPopup from '../../atoms/buttonPopup/buttonPopup';
import { updateForm } from '../../../store/actions/formActions';
import { useNavigate, useLocation } from 'react-router-dom';

const TableSection = (props) => {
  const {
    configFile,
    editURL,
    tableName,
    valuesPaginated,
    onClickCreate,
    onChangePage,
    onSearch,
    onSort,
    onChangeItem,
    onChangeRow,
    onChangeItemPosition,
    onClickRemoveItem,
    onOrderItems,
    onClickRow,
    onClickBulkDelete,
    onChangeAndRefresh,
    history,
    match,
    initDataSelected,
    customEditUrl,
    maxElementsSelectable,
    onSelectUrl,
    mode,
    onBulkAction,
    itemId,
    onAfterEdit,
    initialValuesRef
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const label = configFile.label ? configFile.label : '';
  const helpText = configFile.helpText ? configFile.helpText : '';
  const canOpen = configFile.canOpen !== undefined ? configFile.canOpen : true;
  const canChangePosition = configFile.canChangePosition !== undefined
    ? configFile.canChangePosition : false;
  const sortingPositionIndex = canChangePosition === true ? configFile.sortingPositionIndex : '';
  const canEdit = configFile.canEdit !== undefined ? configFile.canEdit : false;
  const canCreate = configFile.canCreate !== undefined ? configFile.canCreate : false;
  const canRemove = configFile.canRemove !== undefined ? configFile.canRemove : false;
  const canRemoveWhen = configFile.canRemoveWhen !== undefined ? configFile.canRemoveWhen : null;
  const canModify = configFile.canModify !== undefined ? configFile.canModify : false;
  const isSelectable = configFile.isSelectable !== undefined ? configFile.isSelectable : false;
  const isMultiSelectable = configFile.isMultiSelectable !== undefined
    ? configFile.isMultiSelectable : false;
  const bulkSelectable = configFile.bulkSelectable !== undefined ? configFile.bulkSelectable : false;
  const bulkButtons = configFile.bulkButtons !== undefined ? configFile.bulkButtons : [];

  const { emptyMessage, emptyButtonUrl, emptyButton, createButton, createButtonUrl } = configFile;
  const createPath = configFile.createPath !== undefined ? getLink(configFile.createPath, location.pathname) : '';
  const fromCatalogTable = configFile.fromCatalogTable !== undefined
    ? configFile.fromCatalogTable : undefined;
  const isDragable = configFile.isDragable !== undefined ? configFile.isDragable : false;
  const dispatch = useDispatch();
  const errorState = useSelector((state) => state[storeStructure.Errors]);
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const [popupShow, setPopupShow] = useState(false);
  const [popupMode, setPopupMode] = useState(null);
  const [popupLabel, setPopupLabel] = useState(null);
  const [popupData, setPopupData] = useState(null);
  const [popupError, setPopupError] = useState(null);
  const [valueTable, setValueTable] = useState(null);
  const [configModalForm, setConfigModalForm] = useState(null);
  const [dataSel, setDataSel] = useState([]);

  useEffect(() => {
    if (valuesPaginated)
      setValueTable(valuesPaginated);
  }, [valuesPaginated]);

  useEffect(() => {
    setDataSel(initDataSelected);
  }, [initDataSelected]);

  const handlerClickNew = () => {
    if (mode == "POPUP") {
      setPopupMode("new");
      let configNewFields = JSON.parse(JSON.stringify(configFile.popupContentFormNew[0].fields));
      configNewFields.push({
        attributeName: 'modeForm',
        label: 'Mode form',
        type: FormInputTypes.TEXT_INPUT.TEXT,
        default: 'new',
        hidden: true
      });
      let newConfigFileNew = JSON.parse(JSON.stringify(configFile.popupContentFormNew));
      newConfigFileNew[0].fields = configNewFields;
      // setConfigModalForm(configFile.popupContentFormEdit);
      setConfigModalForm(newConfigFileNew);
      // setConfigModalForm(configFile.popupContentFormNew);
      setPopupLabel(configFile.popupContentFormNew[0].title);
      setPopupShow(true);
    }
  }
  const handlerSecondaryForm = () => {
    setPopupMode("secondary");
    setConfigModalForm(configFile.popupContentFormSecondary);
    setPopupLabel(configFile.popupContentFormSecondary[0].title);
    setPopupShow(true);
  }
  const handleClickEdit = (row) => {
    // console.log("1");
    if (mode == "POPUP") {
      // console.log("2");
      let editId = undefined;
      let location = window.location.pathname;
      let locationArr = location.split("/");
      // console.log("locationArr",locationArr);
      // editId="/"+locationArr[locationArr.length-1];
      // let validationUrl=configFile.editURL +editId+"/"+row.id;
      let lastId = locationArr[locationArr.length - 1];
      if (isNumber(lastId)) {
        editId = lastId;//locationArr[locationArr.length-1];
      }
      // console.log("editId",editId, configFile.updateURL);
      // let validationUrl=configFile.updateURL +editId;
      const url = composeURL(session, configFile.sessionParams, configFile.updateURL, editId);
      // console.log("url",url);
      httpGet(url + "/" + row.id).then((res) => {
        setPopupData(res);
      }).catch(error => {
        setPopupError(error);
      });
      let configEditFields = JSON.parse(JSON.stringify(configFile.popupContentFormEdit[0].fields));
      configEditFields.push({
        attributeName: 'popupMode',
        label: 'Mode form',
        type: FormInputTypes.TEXT_INPUT.TEXT,
        default: 'edit',
        hidden: true
      });
      let newConfigFileEdit = JSON.parse(JSON.stringify(configFile.popupContentFormEdit));
      newConfigFileEdit[0].fields = configEditFields;
      // setConfigModalForm(configFile.popupContentFormEdit);
      setConfigModalForm(newConfigFileEdit);
      setPopupLabel(configFile.popupContentFormEdit[0].title);
      setPopupMode("edit");
      setPopupShow(true);
    } else {
      // console.log("3");
      if (customEditUrl) {
        let params = ["appId", "areaId"];
        navigate(composeURL(session, params, customEditUrl, row.id), {
          state: {
            from: location.pathname,
          },
        });
        return;
      }
      if (configFile.editURL !== undefined) {
        navigate(getLink(configFile.editURL, location.pathname, row.id), {
          state: {
            from: location.pathname,
          },
        });
      } else {
        // eslint-disable-next-line no-console
        console.error('You must to define a editURL attribute on configFile');
      }
    }

  };
  const handleClickModify = (row) => {
    if (configFile.editURL !== undefined) {
      navigate(getLink(configFile.modifyURL, location.pathname, row.id), {
        state: {
          from: location.pathname,
        },
      });
    } else {
      // eslint-disable-next-line no-console
      console.error('You must to define a editURL attribute on configFile');
    }
  };
  const handlerDragEnd = (result) => {
    const { source } = result;
    const { destination } = result;
    const newValues = { ...valuesPaginated };
    const [removed] = newValues.data.splice(source.index, 1);

    if (sortingPositionIndex !== '') {
      removed[sortingPositionIndex] = destination.index
        + (valuesPaginated.perPage * (valuesPaginated.currentPage - 1));
    }
    newValues.data.splice(destination.index, 0, removed);

    if (sortingPositionIndex !== '') {
      newValues.data = newValues.data.map((oldValue, index) => {
        // eslint-disable-next-line no-param-reassign
        const newValue = { ...oldValue };

        newValue[sortingPositionIndex] = index
          + (valuesPaginated.perPage * (valuesPaginated.currentPage - 1));

        return newValue;
      });
    }

    onOrderItems(newValues.data, true);
  };
  const isNumber = (value) => {
    return !isNaN(Number(value));
  }
  const handlerNewPopup = (e, field, values) => {
    let editId = undefined;
    let location = window.location.pathname;
    let locationArr = location.split("/");

    let lastId = locationArr[locationArr.length - 1];
    if (isNumber(lastId)) {
      editId = locationArr[locationArr.length - 1];
    }
    // let validationUrl=configFile.updateURL +editId;

    const url = composeURL(session, configFile.sessionParams, configFile.updateURL, editId);
    httpPut(url, values).then((res) => {
      setPopupShow(false);
      setPopupError(null);
      let p = res[tableName];
      let t = mapPagination(p);
      setValueTable(t);
    }).catch(error => {
      setPopupError(error);
    });
  }
  const handlerChangePopup = (e, field, values) => {
    let editId = "";
    let location = window.location.pathname;
    let locationArr = location.split("/");
    // editId="/"+locationArr[locationArr.length-1];
    let validationUrl = configFile.updateURL + editId;
    if (popupMode == "secondary") {
      validationUrl += "/" + configFile.secondaryParamUrl;
    }
    let lastId = locationArr[locationArr.length - 1];
    if (isNumber(lastId)) {
      editId = "/" + locationArr[locationArr.length - 1];
    }
    let url = "";
    if (popupMode == "secondary") {
      url = composeURL(session, configFile.sessionParams, validationUrl + editId);
    } else {
      url = composeURL(session, configFile.sessionParams, configFile.getURL + editId);
    }
    // const url = composeURL(session, configFile.sessionParams, configFile.getURL+editId);
    httpPut(url, values).then((res) => {
      setPopupShow(false);
      setPopupError(null);
      let p = res[tableName];
      let t = mapPagination(p);
      setValueTable(t);
      if (onAfterEdit) {
        onAfterEdit(res, dispatch, updateForm, initialValuesRef);
      }
    }).catch(error => {
      setPopupError(error);
    });
  }

  const handleOnChangeAndRefresh = (data) => {
    let newTableData = data[tableName];
    let p = mapPagination(newTableData);
    setValueTable(p);
    onChangeAndRefresh(data);
  }
  const handlerClosePopup = () => {
    setPopupMode(null);
    setPopupShow(false);
  }
  const handlerBulkAction = (action, dataSelected, type) => {
    onBulkAction(action, dataSelected, type).then(() => {
      setDataSel([]);
    });
  }
  const handleClickRow = (data) => {
    onClickRow(data);
  }
  return (
    <div className="form-group" data-component="tableSectionv3">
      {configFile.newButton && <Button
        id={`${"btn-" + configFile.attributeName}`}
        theme={ButtonTheme.PRIMARY}
        className={"btn btn-primary btn-sm " + configFile.attributeName + "--new"}
        onClick={handlerClickNew}
      >
        New
      </Button>}
      {configFile.secondaryButtonText && <Button
        id={`${configFile.attributeName}`}
        theme={ButtonTheme.SUCCESS}
        className={"btn btn-primary btn-sm " + configFile.attributeName + "--secondaryButton" + " popupTable-button-margin-left"}
        onClick={handlerSecondaryForm}
      >
        {configFile.secondaryButtonText}
      </Button>}
      <div className={`row text-${errorState[configFile.attributeName] !== undefined ? FormValidation.ERROR : FormValidation.PENDING}`}>
        <Label helpText={helpText}>
          {label}
        </Label>
      </div>
      {(errorState[configFile.attributeName] !== undefined)
        && (
          <div className={`text-${errorState[configFile.attributeName] !== undefined ? FormValidation.ERROR : FormValidation.PENDING}`}>
            <small className="form-text">{errorState[configFile.attributeName]}</small>
          </div>
        )}
      {createPath !== ''
        && (
          <div>
            <Link
              id={`${configFile.attributeName}-new`}
              icon={IconType.NEW}
              theme={LinkTheme.PRIMARY}
              to={createPath}
            >
              New
            </Link>
            {fromCatalogTable !== undefined
              && (
                <LoadFromCatalogButton
                  id={"fromCatalog"}
                  label={label}
                  configFile={fromCatalogTable}
                  fromCatalogText={(configFile.fromCatalogText ? configFile.fromCatalogText : null)}
                  multiple={configFile?.fromCatalogTableMultiple ?? false}
                />
              )}
            {configFile.bulkDelete && initDataSelected.length > 0 &&
              <Button onClick={() => onClickBulkDelete(initDataSelected)} theme={ButtonTheme.ERROR}>{`Delete ${initDataSelected.length} item${initDataSelected.length != 1 ? 's' : ''}`}</Button>
            }
          </div>
        )}
      {bulkSelectable && <div><div className="float-left">{dataSel.length} records selected</div>
        {bulkButtons && bulkButtons.map((but, index) => {
          let extraParams = [];
          if (but.action == "bulkImport" && but.sessionParams && but.sessionParams.length > 0) {
            but.sessionParams.map((ses) => {
              extraParams.push({
                attributeName: ses,
                type: FormInputTypes.TEXT_INPUT.TEXT,
                required: true,
                label: ses,
                hidden: true,
                defaultValue: session[ses]
              });
            });
          }

          return (
            <div key={index} className="mb-1 mx-1 float-right">
              {but.action == "bulkImport" &&
                <ButtonPopup
                  id={"button-" + but.action}
                  buttonText={but.label}
                  theme={(but.color ? but.color : ButtonTheme.PRIMARY)}
                  actionUrl={but.actionUrl}
                  refreshIfOk={true}
                  formConfig={
                    {
                      title: 'Import from zip file',
                      description: 'Import from a zip file',
                      attributeName: 'newImport',
                      fields: [
                        ...extraParams,
                        {
                          attributeName: 'zipfile',
                          required: true,
                          type: FormInputTypes.DOWNLOADABLE,
                          label: 'Zip file',
                          helpText: 'Zip file to upload.',
                          fileType: ['.zip'],
                        },
                        ...but.formConfig
                      ]
                    }
                  }
                />
              }
              {but.action != "bulkImport" &&
                but.hidden == "no-selection" && initDataSelected.length != 0 && <Button
                  id={`button-` + but.action}
                  type={ButtonType.BUTTON}
                  onClick={() => { handlerBulkAction(but.action, dataSel, but.type) }}
                  theme={(but.color ? but.color : ButtonTheme.PRIMARY)}
                  disabled={(but.disabled == "no-selection" && dataSel.length == 0)}
                  title={(but.title ? but.title : '')}
                >
                  {!but.showNumberElems && <span>{but.label} </span>}
                  {but.showNumberElems && <span>{but.label} {dataSel.length} selected</span>}
                </Button>
              }
            </div>);
        })}
      </div>
      }
      {valueTable && <div className="table-responsive">
        <Table
          id={configFile.attributeName}
          dataSet={valueTable.data}
          columnSet={configFile.fields}
          label={label}
          canEdit={canEdit}
          canRemove={canRemove}
          canRemoveWhen={canRemoveWhen}
          canModify={canModify}
          onChange={onChangeItem}
          onChangeRow={onChangeRow}
          onChangePosition={onChangeItemPosition}
          canOpen={canOpen}
          canChangePosition={canChangePosition}
          sortingPositionIndex={sortingPositionIndex}
          canCreate={canCreate}
          onClickEdit={handleClickEdit}
          onClickModify={handleClickModify}
          onClickCreate={onClickCreate}
          onClickRemove={onClickRemoveItem}
          onChangeAndRefresh={handleOnChangeAndRefresh}
          onDragEnd={handlerDragEnd}
          isDragable={isDragable}
          emptyMessage={emptyMessage}
          emptyButtonUrl={emptyButtonUrl}
          emptyButton={emptyButton}
          createButton={createButton}
          createButtonUrl={createButtonUrl}
          isSelectable={isSelectable}
          isMultiSelectable={isMultiSelectable}
          maxElementsSelectable={maxElementsSelectable}
          onSelectUrl={onSelectUrl}
          onClickRow={handleClickRow}
          initDataSelected={initDataSelected}
          onSearch={onSearch}
          onSort={onSort}
          bulkSelectable={bulkSelectable}
          itemId={itemId}
        />
        <TablePagination
          tableId={configFile.attributeName}
          currentPage={valueTable.currentPage}
          firstPageUrl={valueTable.firstPageUrl}
          from={valueTable.from}
          lastPage={valueTable.lastPage}
          lastPageUrl={valueTable.lastPageUrl}
          nextPageUrl={valueTable.nextPageUrl}
          path={valueTable.path}
          perPage={valueTable.perPage}
          prevPageUrl={valueTable.prevPageUrl}
          to={valueTable.to}
          total={valueTable.total}
          onChangePage={onChangePage}
        />
      </div>}
      {valueTable && <FormPopup size={'xl'} id={configFile.attributeName + "-popup"} mode={popupMode} nextId={configFile.attributeName + "-popup"} title={popupLabel}
        configFile={configModalForm}
        field={configFile.attributeName}
        value={popupData}
        show={popupShow} params={''}
        uniqueId={configFile.attributeName + "-popup"} parentUID={configFile.attributeName + "-popup"}
        parentData={configFile.attributeName + "-popup"}
        popupError={popupError}
        // customSession={(valueTable.data["customSession"]?valueTable.data["customSession"]:null)}
        onNewPopup={handlerNewPopup}
        onEditPopup={handlerChangePopup}
        onClosePopup={handlerClosePopup} />}
    </div>
  );
};

TableSection.propTypes = {
  /**
   * Text to help the user. It is added to the Help Button atom.
   */
  helpText: PropTypes.string,
  /**
   * Text of new item buttom
   */
  createText: PropTypes.string,
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({}).isRequired,
  /**
   * Data table set loading from redux
   */
  valuesPaginated: PropTypes.shape({}),
  /**
   * Event when the user click on next or prev page of table pagination
   */
  onChangePage: PropTypes.func,
  onSearch: PropTypes.func,
  onSort: PropTypes.func,
  onClickCreate: PropTypes.func,
  onChangeItem: PropTypes.func,
  onClickRemoveItem: PropTypes.func,
  onOrderItems: PropTypes.func,
  onClickRow: PropTypes.func,
  onChangeItemPosition: PropTypes.func,
  onClickBulkDelete: PropTypes.func,
  initDataSelected: PropTypes.arrayOf(PropTypes.shape({})),
  customEditUrl: PropTypes.string,
  maxElementsSelectable: PropTypes.number,
  onSelectUrl: PropTypes.string,
  onAfterEdit: PropTypes.func,
};

TableSection.defaultProps = {
  helpText: '',
  createText: 'New Item',
  valuesPaginated: {},
  onChangePage: () => { },
  onSearch: () => { },
  onSort: () => { },
  onClickCreate: () => { },
  onChangeItem: () => { },
  onClickRemoveItem: () => { },
  onOrderItems: () => { },
  onClickRow: () => { },
  onChangeItemPosition: () => { },
  onClickBulkDelete: () => { },
  initDataSelected: [],
  customEditUrl: null,
  maxElementsSelectable: null,
  onAfterEdit: null,
  initialValuesRef: null,
};

export default TableSection;
